



































































import {
  Component, Vue,
} from 'vue-property-decorator';
import EditRetirementFundCurrentPlanViewModel
  from '@/vue-app/view-models/components/goals-dashboard/edit-plan-goals/edit-retirement-fund-goal-plan/edit-retirement-fund-current-plan-view-model';

@Component({ name: 'EditRetirementFundCurrentPlan' })
export default class EditRetirementFundCurrentPlan extends Vue {
  edit_retirement_current_plan_view_model = Vue.observable(
    new EditRetirementFundCurrentPlanViewModel(this),
  );

  mounted() {
    this.edit_retirement_current_plan_view_model.initialize();
  }
}
